import { render, staticRenderFns } from "./jbdfyh.vue?vue&type=template&id=504a1e1a&scoped=true"
import script from "./jbdfyh.vue?vue&type=script&lang=js"
export * from "./jbdfyh.vue?vue&type=script&lang=js"
import style0 from "./jbdfyh.vue?vue&type=style&index=0&id=504a1e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504a1e1a",
  null
  
)

export default component.exports